<div class="row mx-0">
  <div class="article-container d-flex flex-wrap" [ngClass]="justify">
    @for (article of articles; track article) {
      <div class="col-12 col-md-4 col-lg-6 col-xl-4 align-items-stretch">
        <app-article-card [article]="article" class="card d-flex px-0 px-sm-2" [gotoDetailsPage]="false"></app-article-card>
      </div>
    }
  </div>
</div>
